import React, { useContext } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';
import AdminLayout from './layout/AdminLayout';
import AuthLayout from './layout/AuthLayout';
import Login from './views/login/Login';
import Forbidden from './error/Forbidden';
import NotFound from './error/NotFound';
import productRoutes from './views/product/routes';
import courseRoutes from './views/course/routes';
import categoryRoutes from './views/category/routes';
import studentRoutes from './views/student/routes';
import orderRoutes from './views/order/routes';
import userRoutes from './views/user/routes';
import attendanceRoutes from './views/attendance/routes';
// import orderRoutes from './views/order/routes';
import dashboardRoutes from './views/dashboard/routes';
import { AuthContext } from './contexts/AuthContext';

import dayjs from 'dayjs';

export default function Router() {

    const { user } = useContext(AuthContext);
    const isAuth = !!JSON.parse(user)

    // console.log(dayjs().toISOString());

    return useRoutes([
        {
            path: 'admin',
            element: <AdminLayout />,
            children: [
                ...productRoutes,
                ...categoryRoutes,
                ...studentRoutes,
                ...userRoutes,
                ...orderRoutes,
                ...dashboardRoutes,
                ...courseRoutes,
                ...attendanceRoutes
            ]
        },
        {
            path: '/',
            element: <AuthLayout />,
            children: [
                {
                    path: 'login',
                    element: <Login />
                },
                {
                    path: '/',
                    // element: isAuth ? <Navigate to={`/admin/dashboard`} replace={true} /> : <Navigate to="/login" replace={true} />
                    element: isAuth ? <Navigate to={`/admin/dashboard?start_date=${dayjs().toISOString()}&end_date=${dayjs().add(1,'days').toISOString()}`} replace={true} /> : <Navigate to="/login" replace={true} />
                },
            ]
        },
        { path: '/forbidden', element: <Forbidden /> },
        { path: '*', element: <NotFound /> }
    ])
}